"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _compareAsc = _interopRequireDefault(require("date-fns/compareAsc"));

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _ru = _interopRequireDefault(require("date-fns/locale/ru"));

var _constants = require("../../constants");

var _constants2 = require("./constants");

var _renderDayContens = _interopRequireDefault(require("./components/renderDayContens"));

var _renderCustomHeader = _interopRequireDefault(require("./components/renderCustomHeader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _reactDatepicker.registerLocale)('ru', _ru["default"]);

var Calendar = function Calendar(_ref) {
  var open = _ref.open,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      onChange = _ref.onChange,
      minDate = _ref.minDate,
      isEndDateFocus = _ref.isEndDateFocus,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$isWizard = _ref.isWizard,
      isWizard = _ref$isWizard === void 0 ? false : _ref$isWizard,
      searchCalendarDuration = _ref.searchCalendarDuration,
      indicationMap = _ref.indicationMap,
      directFlightsInfo = _ref.directFlightsInfo,
      setStartCurrentMonth = _ref.setStartCurrentMonth,
      isHotelOnly = _ref.isHotelOnly,
      isHotelVariant = _ref.isHotelVariant;
  var calcMaxDate = (0, _react.useCallback)(function () {
    var maximumShowDays = (0, _addDays["default"])(new Date(), isHotelOnly ? _constants2.MAXIMUM_SHOW_HOTEL_DAYS : _constants2.MAXIMUM_SHOW_DAYS);

    if (startDate && isEndDateFocus) {
      var maximumNights = (0, _addDays["default"])(startDate, _constants2.MAXIMUM_NIGHTS);

      if ((0, _compareAsc["default"])(new Date(maximumNights), new Date(maximumShowDays)) < 0) {
        return maximumNights;
      }
    }

    return maximumShowDays;
  }, [startDate, isEndDateFocus, isHotelOnly]);
  if (!open) return null;
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    $isMobile: isMobile,
    $isWizard: isWizard,
    $isHotelVariant: isHotelVariant
  }, /*#__PURE__*/_react["default"].createElement(StyledReactDatePicker, {
    locale: "ru",
    startDate: startDate,
    endDate: endDate,
    minDate: minDate,
    showPopperArrow: false,
    onChange: onChange,
    selectsEnd: isEndDateFocus,
    renderDayContents: (0, _renderDayContens["default"])({
      startDate: startDate,
      endDate: endDate,
      isMobile: isMobile,
      searchCalendarDuration: searchCalendarDuration,
      indicationMap: indicationMap,
      directFlightsInfo: directFlightsInfo,
      isHotelVariant: isHotelVariant
    }),
    openToDate: startDate || minDate,
    disabledKeyboardNavigation: true,
    maxDate: calcMaxDate() // нет в @types/react-datepicker

    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */

    /* @ts-ignore */
    ,
    selectsDisabledDaysInRange: true,
    inline: true,
    monthsShown: isMobile ? _constants2.MONTH_COUNT_MOBILE : _constants2.MONTH_COUNT,
    renderCustomHeader: (0, _renderCustomHeader["default"])({
      isMobile: isMobile,
      setStartCurrentMonth: setStartCurrentMonth
    })
  }));
};

exports.Calendar = Calendar;
var StyledReactDatePicker = (0, _styledComponents["default"])(_reactDatepicker["default"]).withConfig({
  displayName: "Calendar__StyledReactDatePicker",
  componentId: "sc-1v7m39j-0"
})(["width:100%;"]);

var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Calendar__StyledWrapper",
  componentId: "sc-1v7m39j-1"
})(["height:100%;.", "{font-family:inherit !important;border:none;display:flex;flex-direction:column;width:100%;align-items:center;background-color:#fff;", " ", ";&__header{background-color:#fff;border:none;padding:0;}&__current-month{color:var(--black);font-size:16px;font-style:normal;font-weight:500;text-transform:capitalize;border:none;margin-bottom:16px;}&__day-name{color:var(--grey2);font-size:12px;&:nth-last-child(-n + 2){color:", ";}&s{display:flex;justify-content:space-around;padding:0 16px;}}&__month{padding:8px 16px 16px;margin:0;}&__week{display:flex;}&__day{width:", ";height:", ";", " margin:2px;border-radius:0;font-size:18px;line-height:22px;color:#4d4d4d;&--disabled{color:#c2c5cc;}&--in-range{background-color:var(--lightorange);color:#4d4d4d;border-radius:var(--border-radius);&:hover{background-color:var(--lightorange);}}&--in-selecting-range{background-color:var(--lightorange);border-radius:var(--border-radius);&:not(.", "__day--in-range){background-color:var(--lightorange);}& > div{background-color:transparent;}}&--selecting-range{&-start,&-end{background-color:transparent;}}&--range-start,&--range-end{color:#17181a;font-weight:500;position:relative;&:before{position:absolute;left:0;top:-12px;font-size:9px;line-height:12px;font-weight:normal;padding:0 4px;border-radius:4px 4px 0 0;}}&.", "__day--outside-month{*{display:none;}background-color:transparent !important;border:none;color:transparent;&:before{content:none;}}}}", ""], _constants.datepickerName, function (_ref2) {
  var $isMobile = _ref2.$isMobile,
      $isWizard = _ref2.$isWizard;
  return $isMobile && !$isWizard && "\n        z-index: 120;\n      ";
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return !$isMobile && "\n        display: inline-block;\n        width: 740px;\n        z-index: 999;\n      ";
}, function (_ref4) {
  var $isHotelVariant = _ref4.$isHotelVariant;
  return $isHotelVariant ? "var(--secondary)" : "var(--secondary-header)";
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return "".concat(!$isMobile ? '44px' : 'calc((100vw - 60px) / 7)');
}, function (_ref6) {
  var $isMobile = _ref6.$isMobile;
  return "".concat(!$isMobile ? '44px' : 'calc((100vw - 60px) / 7)');
}, function (_ref7) {
  var $isMobile = _ref7.$isMobile;
  return $isMobile && "\n        max-width: 100px;\n        max-height: 100px;\n      ";
}, _constants.datepickerName, _constants.datepickerName, function (_ref8) {
  var $isMobile = _ref8.$isMobile,
      $isWizard = _ref8.$isWizard;
  return $isMobile && "\n      ".concat(!$isWizard && "width: 100%;", "\n      display: flex;\n      justify-content: center;\n      overflow-y: scroll;\n    ");
});